module.exports = require("stream");;